/*  ========================================================================
    # Posts - Index
    ========================================================================  */

import React from 'react';
import { createRoot, type Container } from 'react-dom/client';
import type { Post } from '@/react/types/post';
import Posts from './Posts';

export type PostsProps = {
  headline: string;
  displayType: 'all_posts' | 'single_category' | 'selected_posts ' | 'newest';
  categories: Array<{
    term_id: number;
    name: string;
    slug: string;
    term_group: number;
    term_taxonomy_id: number;
    taxonomy: string;
    description: string;
    parent: number;
    count: number;
    filter: string;
    cat_ID: number;
    category_count: number;
    category_description: string;
    cat_name: string;
    category_nicename: string;
    category_parent: number;
  }>;
  ctaText: string;
  ctaLink: { title: string; url: string } | null;
  predefinedPosts: Post[];
  showCategoryPagination: boolean;
  preSelectedCategory: number[];
  link: { title: string; url: string } | null;
  excludedCategories: number[];
};

const containers = document.querySelectorAll('div[data-react-app="posts"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = (containers[i]?.attributes as any)['data-guid']?.value;
  const props = (window as any).reactProps[containerGuid] as PostsProps;

  createRoot(containers[i] as Container).render(<Posts {...props} />);
}
